/* Awtomic Build-a-Box customization — per-shop behavior + layout injection.
   Loaded by snippets/awtomic-theme-custom.liquid.
   Edit ONLY the SHOP CONFIG block below. Everything underneath hooks the
   Awtomic widget's own class names and works unchanged on any theme — do not
   edit it unless the widget markup itself has changed. */

/* ==================================================================== */
/* ===== SHOP CONFIG — EDIT THIS ====================================== */
/* ==================================================================== */

/* CONFIGURE: one entry per Build-a-Box bundle id — the number at the end of
   /tools/bundle-subscriptions/bundle/<id>. The "default" entry is the fallback
   for any bundle id not listed, so always keep it and give it real copy.
   Fields:
     title  — heading shown over the banner image
     header — HTML block shown above the product grid ("items header")
     info   — HTML for the description (left) + details box (right)
     img    — banner image. EITHER a full URL (e.g. a Shopify Files image:
              "https://cdn.shopify.com/s/files/.../hero.jpg?width=1600") OR a
              filename uploaded to this theme's assets/ ("hero.jpg"). The URL
              form is usually easier — the merchant can swap the image in
              Content → Files without a theme deploy. */
const babInfoMapping = {
  8647809892527: {
    title: "The Bluebonnet Club",
    header:
      '<div class="main-bab-header"><h3>Build your Bluebonnet shipment</h3><p>Texas&rsquo; own, and the one everyone waits for.</p></div>',
    info: `
      <div>
        <h3>The Bluebonnet Club</h3>
        <p>Named for the flower that turns our fields blue every spring. Twelve bottles a shipment, chosen entirely by you.</p>
      </div>
      <aside>
        <h4>Membership Details</h4>
        <ul>
          <li>Choose any 12 bottles per shipment.</li>
          <li>Pick dry or sweet, or mix the two.</li>
          <li>Shipments arrive on the schedule you set.</li>
          <li>Wines ship direct from Wildseed Farms.</li>
        </ul>
      </aside>
    `
  },
  8647811399855: {
    title: "The Paintbrush Club",
    header:
      '<div class="main-bab-header"><h3>Build your Paintbrush shipment</h3><p>A half case, built your way.</p></div>',
    info: `
      <div>
        <h3>The Paintbrush Club</h3>
        <p>Named for the Indian paintbrush that burns orange beside the bluebonnets. Six bottles a shipment, chosen entirely by you.</p>
      </div>
      <aside>
        <h4>Membership Details</h4>
        <ul>
          <li>Choose any 6 bottles per shipment.</li>
          <li>Pick dry or sweet, or mix the two.</li>
          <li>Shipments arrive on the schedule you set.</li>
          <li>Wines ship direct from Wildseed Farms.</li>
        </ul>
      </aside>
    `
  },
  8647814545583: {
    title: "The Wine Cup Club",
    header:
      '<div class="main-bab-header"><h3>Build your Wine Cup shipment</h3><p>A small, considered shipment.</p></div>',
    info: `
      <div>
        <h3>The Wine Cup Club</h3>
        <p>Named for the wine cup that opens deep magenta across the hill country. Four bottles a shipment, chosen entirely by you.</p>
      </div>
      <aside>
        <h4>Membership Details</h4>
        <ul>
          <li>Choose any 4 bottles per shipment.</li>
          <li>Pick dry or sweet, or mix the two.</li>
          <li>Shipments arrive on the schedule you set.</li>
          <li>Wines ship direct from Wildseed Farms.</li>
        </ul>
      </aside>
    `
  },
  8647821623471: {
    title: "The Industry Club",
    header:
      '<div class="main-bab-header"><h3>Build your Industry shipment</h3><p>Three bottles, from the town that started it.</p></div>',
    info: `
      <div>
        <h3>The Industry Club</h3>
        <p>Named for Industry, Texas, the oldest German settlement in the state and home to our winery. Three bottles a shipment, chosen entirely by you.</p>
      </div>
      <aside>
        <h4>Membership Details</h4>
        <ul>
          <li>Choose any 3 bottles per shipment.</li>
          <li>Pick dry or sweet, or mix the two.</li>
          <li>Shipments arrive on the schedule you set.</li>
          <li>Wines ship direct from Wildseed Farms.</li>
        </ul>
      </aside>
    `
  },
  // Fallback for any bundle id not listed above.
  default: {
    title: "Wildseed Farms Wine Club",
    header:
      '<div class="main-bab-header"><h3>Build your shipment</h3><p>Choose the wines you want, on the schedule you want.</p></div>',
    info: `
      <div>
        <h3>Wildseed Farms Wine Club</h3>
        <p>Wines from our Industry, Texas winery, chosen by you and shipped on your schedule.</p>
      </div>
      <aside>
        <h4>Membership Details</h4>
        <ul>
          <li>Choose your wines each shipment.</li>
          <li>Pick dry or sweet, or mix the two.</li>
          <li>Shipments arrive on the schedule you set.</li>
        </ul>
      </aside>
    `
  }
};

/* CONFIGURE: optional per-bundle minimum box price, enforced on the BaB
   add-to-cart button (purchase flow AND customer-portal edit).
   Shape: bundleId -> { variantId -> minimum price, ... }.
   Leave empty ({}) to disable minimum-price enforcement. */
const babMinimums = {
  // "9556565229815": {
  //   49231431958775: 60,
  //   49231431991543: 120
  // }
};

/* CONFIGURE: optional post-BaB upsell popup, shown after "add to cart".
   Leave variantId unset (or the whole object empty) and no popup appears —
   the customer goes straight to the cart. */
window.babUpsellConfig = {
  // variantId: 49231431958775,               // Shopify variant id added on Accept
  // heading: "Exclusive New Member Offer",
  // description: "Add this to your first shipment.",
  // productTitle: "Library Cabernet",
  // imageUrl: "https://cdn.shopify.com/...", // product image URL
  // priceLabel: "$45",
  // compareAtLabel: "$60",
};

/* CONFIGURE: optional external cancel-flow URL (no query string). When set,
   the customer-portal Cancel button opens
   <url>?winery=<shop>&token=<portal token>&sub=<subscription id> in a new tab
   instead of the widget's native cancel flow. Leave "" for native cancel. */
const babCancelRedirectUrl = "";

/* CONFIGURE: optional overrides for the Awtomic Cart Rollup library
   (awtomic-cart-extras — loaded from snippets/awtomic-theme-custom.liquid; see
   the OPTIONAL: cart rollup block there). The library auto-detects the common
   Shopify themes, so MOST SHOPS NEED NOTHING HERE — leave it commented out.
   Only supply a `theme` override for a theme it can't detect, and only turn on
   debugMode while debugging (it logs to every visitor's console). */
// window.awtomicCartExtrasConfig = {
//   debugMode: false,
//   theme: {
//     name: "Custom",
//     detect: () => true,
//     selectors: { /* see the library's theme definitions for the shape */ },
//   },
// };

/* ==================================================================== */
/* ===== END SHOP CONFIG — do not edit below this line ================ */
/* ==================================================================== */

// Clean up hiddenStepper for non-BAB purchase flows
(function () {
  const isBabPurchaseFlow = window.location.pathname.includes("/tools/bundle-subscriptions/bundle/");

  if (!isBabPurchaseFlow) {
    // Immediate cleanup
    document.body.classList.remove("hiddenStepper");
    sessionStorage.removeItem("awtHiddenStepper");

    // Also cleanup on DOMContentLoaded to ensure it's removed
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        document.body.classList.remove("hiddenStepper");
        sessionStorage.removeItem("awtHiddenStepper");
      });
    }
  }
})();

// ===== Build-A-Box upsell popup =====
const babUpsell = (() => {
  let modalEl = null;
  let lastFocusedEl = null;

  const buildModal = () => {
    const cfg = window.babUpsellConfig || {};
    const wrap = document.createElement("div");
    wrap.className = "bab-upsell-modal";
    wrap.setAttribute("role", "dialog");
    wrap.setAttribute("aria-modal", "true");
    wrap.setAttribute("aria-labelledby", "bab-upsell-title");
    wrap.setAttribute("aria-hidden", "true");
    wrap.innerHTML = `
      <div class="bab-upsell-modal__dialog" tabindex="-1">
        <button type="button" class="bab-upsell-modal__close" data-bab-upsell-close aria-label="Close">&times;</button>
        <h2 class="bab-upsell-modal__title" id="bab-upsell-title">${escapeHtml(cfg.heading || "Exclusive New Member Offer")}</h2>
        <p class="bab-upsell-modal__subtitle">${escapeHtml(cfg.description || "")}</p>
        <div class="bab-upsell-modal__product">
          <div class="bab-upsell-modal__image-wrap">
            ${cfg.imageUrl ? `<img src="${escapeAttr(cfg.imageUrl)}" alt="${escapeAttr(cfg.productTitle || "")}" />` : ""}
          </div>
          <h3 class="bab-upsell-modal__product-title">${escapeHtml(cfg.productTitle || "")}</h3>
          <div class="bab-upsell-modal__pricing">
            ${cfg.compareAtLabel ? `<div class="bab-upsell-modal__compare-at">Price: <span>${escapeHtml(cfg.compareAtLabel)}</span></div>` : ""}
            <div class="bab-upsell-modal__offer">Offer Price: <span>${escapeHtml(cfg.priceLabel || "")}</span></div>
          </div>
        </div>
        <div class="bab-upsell-modal__actions">
          <button type="button" class="bab-upsell-modal__btn bab-upsell-modal__accept" data-bab-upsell-accept>Accept</button>
          <button type="button" class="bab-upsell-modal__btn bab-upsell-modal__decline" data-bab-upsell-decline>Decline</button>
        </div>
      </div>
    `;
    document.body.appendChild(wrap);
    return wrap;
  };

  const escapeHtml = (str) => String(str).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const escapeAttr = (str) => escapeHtml(str);

  const finish = (discount) => {
    if (discount) {
      window.location.assign(`/discount/${encodeURIComponent(discount)}?redirect=/cart`);
    } else {
      window.location.assign("/cart");
    }
  };

  const close = () => {
    if (!modalEl) return;
    modalEl.classList.remove("bab-upsell-modal--open");
    modalEl.setAttribute("aria-hidden", "true");
    document.body.classList.remove("bab-upsell-locked");
    document.removeEventListener("keydown", onKeydown);
    if (lastFocusedEl && typeof lastFocusedEl.focus === "function") {
      lastFocusedEl.focus();
    }
  };

  const onKeydown = (e) => {
    if (e.key === "Escape") {
      e.preventDefault();
      const decline = modalEl?.querySelector("[data-bab-upsell-decline]");
      decline?.click();
    }
  };

  const open = (discount) => {
    if (!modalEl) modalEl = buildModal();
    const cfg = window.babUpsellConfig || {};
    if (!cfg.variantId) {
      console.warn("[bab-upsell] No variantId configured; skipping popup");
      finish(discount);
      return;
    }

    lastFocusedEl = document.activeElement;
    modalEl.classList.add("bab-upsell-modal--open");
    modalEl.setAttribute("aria-hidden", "false");
    document.body.classList.add("bab-upsell-locked");

    const dialog = modalEl.querySelector(".bab-upsell-modal__dialog");
    dialog?.focus();

    const acceptBtn = modalEl.querySelector("[data-bab-upsell-accept]");
    const declineBtn = modalEl.querySelector("[data-bab-upsell-decline]");
    const closeBtn = modalEl.querySelector("[data-bab-upsell-close]");

    const handleDecline = (e) => {
      e?.preventDefault();
      close();
      finish(discount);
    };

    const handleAccept = async (e) => {
      e?.preventDefault();
      acceptBtn.disabled = true;
      declineBtn.disabled = true;
      closeBtn.disabled = true;
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: cfg.variantId, quantity: 1 }] })
        });
      } catch (err) {
        console.error("[bab-upsell] add-to-cart failed", err);
      }
      finish(discount);
    };

    const handleBackdrop = (e) => {
      if (e.target === modalEl) handleDecline(e);
    };

    acceptBtn.onclick = handleAccept;
    declineBtn.onclick = handleDecline;
    closeBtn.onclick = handleDecline;
    modalEl.onclick = handleBackdrop;
    document.addEventListener("keydown", onKeydown);
  };

  return { open };
})();

window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600, /* CONFIGURE (optional): BaB product image size in px */
    addToCartRedirect: ({ discount } = {}) => {
      babUpsell.open(discount);
    }
  }
});

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

//if awtomic customer portal
if (window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=")) {
  document.body.classList.add("awt-cp");

  // Intercept cancel button and redirect to external cancellation flow
  // (only when babCancelRedirectUrl is configured above)
  if (babCancelRedirectUrl) {
    waitForElement(".bundle-button--cancel", (originalBtn) => {
      originalBtn.style.display = "none";

      const clonedBtn = originalBtn.cloneNode(true);
      clonedBtn.style.display = "";
      clonedBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const rawSubscriptionId = window.Awtomic?.subscriptionDetails?.SubscriptionId || "";
        const subscriptionId = rawSubscriptionId.split("/").pop();
        const winery = window.Shopify?.shop || "";
        const token = (() => {
          try {
            const raw = localStorage.getItem("awtomicApiAuth");
            return raw ? JSON.parse(raw).authToken || "" : "";
          } catch { return ""; }
        })();

        window.open(
          `${babCancelRedirectUrl}?winery=${encodeURIComponent(winery)}&token=${encodeURIComponent(token)}&sub=${subscriptionId}`,
          "_blank"
        );
      });

      originalBtn.parentNode.insertBefore(clonedBtn, originalBtn.nextSibling);
    });
  }

  // CP PRICE CHECK
  waitForElement(".bundle-table__body-row--bab-parent", (element) => {
    const checkBabEdit = (bundleId, variantId) => {
      const minimumPrice = babMinimums[bundleId]?.[variantId] || 0;

      const setAddToCartMinimumPrice = () => {
        const bundleContainer = document.querySelector(".bundleapp-modal__container--complete-screen > .bundle-container");

        if (!bundleContainer) return;

        const infoDiv = document.createElement("div");
        infoDiv.className = "minimum-price-info";
        infoDiv.innerText = `Minimum price of $${minimumPrice} is required for this club.`;

        const footerDiv = bundleContainer.querySelector("footer > div");
        if (footerDiv) {
          const lastDiv = footerDiv.querySelector("div:last-child");
          if (lastDiv) {
            footerDiv.insertBefore(infoDiv, lastDiv);
          }
        }

        document.body.addEventListener("click", (e) => {
          const price = document.querySelector("div > span.bundle-text--emphasis").innerText;
          const innerPrice = parseFloat(price.replace(/[^0-9.,]/g, "").replace(",", ""));

          const addToCartButton = document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div > button");
          if (innerPrice < minimumPrice) {
            addToCartButton.classList.add("priceNotMet");
            document.body.classList.add("priceNotMet");
          } else {
            addToCartButton.classList.remove("priceNotMet");
            document.body.classList.remove("priceNotMet");
          }
        });
      };

      const checkIfPriceLabel = () =>
        document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div:last-child > div > span:nth-child(2)");

      let priceLabelSet = false;

      if (checkIfPriceLabel()) {
        setAddToCartMinimumPrice();
      } else {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (!priceLabelSet && mutation.addedNodes.length) {
              if (checkIfPriceLabel()) {
                setAddToCartMinimumPrice();
                priceLabelSet = true;
                observer.disconnect();
              }
            }
          });
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });

        setTimeout(() => {
          observer.disconnect();
        }, 5000);
      }
    };

    Object.keys(babMinimums).forEach((bundleId) => {
      Object.keys(babMinimums[bundleId]).forEach((variantId) => {
        const selector = `tr[class*="${variantId}"]`;
        const element = document.querySelector(selector);
        console.log(selector, element);
        if (element) element.addEventListener("click", () => checkBabEdit(bundleId, variantId));
      });
    });
  });
}

//if awtomic subs list / my subscriptions
if (/^\/tools\/bundle-subscriptions\/?$/.test(location.pathname) && !location.search) {
  document.body.classList.add("awt-my-subs");
}

//if awtomic bab purchase flow
if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/")) {
  // Check if coming from product PDP
  const referrer = document.referrer;
  const fromPDP = referrer && referrer.includes("/products/");

  if (fromPDP) {
    document.body.classList.add("hiddenStepper");
    sessionStorage.setItem("awtHiddenStepper", "true");
  } else if (sessionStorage.getItem("awtHiddenStepper") === "true") {
    document.body.classList.add("hiddenStepper");
  }

  window.Awtomic = window.Awtomic || {};
  window.Awtomic.getBabSelection = () => {
    //babProductId is in a class of an element, the element is div.bundle-container.pv_xxxxxxx where xxxxxxx is the bab product id
    const babProductId = document
      .querySelector(".bundle-container")
      ?.className.split(" ")
      .find((c) => c.startsWith("pv_"))
      ?.split("_")[1];
    if (!babProductId) return { object: {}, queryString: "" };

    const bundleProductCards = document.querySelectorAll(".bundle-product-card");

    const bundleSelectedProducts = {};
    bundleProductCards.forEach((card) => {
      const productId = card.getAttribute("data-pid");
      const quantityElement = card.querySelector(".bundle-product-card__quantity-button-container > span");
      const quantity = quantityElement ? parseInt(quantityElement.innerHTML) : 0;

      if (productId && quantity > 0) {
        bundleSelectedProducts[productId] = quantity;
      }
    });

    // Create query string format
    const queryString = Object.entries(bundleSelectedProducts)
      .map(([id, quantity]) => `${id}=${quantity}`)
      .join("&");

    // Create full URL with query string
    const currentUrl = window.location.href;
    const separator = currentUrl.includes("?") ? "&" : "?";
    const fullUrl = queryString ? `${currentUrl}${separator}${queryString}` : currentUrl;

    return {
      object: { [babProductId]: bundleSelectedProducts },
      queryString: queryString,
      fullUrl: fullUrl
    };
  };

  const urlParts = window.location.pathname.split("/");
  const bundleId = urlParts[urlParts.length - 1];
  if (bundleId) {
    document.body.classList.add(`awt-bundle-${bundleId}`);

    if (babMinimums[bundleId]) {
      // Wait for footer to exist first, then set up the price checking
      waitForElement(".bundleapp-modal__container--complete-screen footer", () => {
        // Get variant ID from bundle container classes (e.g., div.bundle-container p_9556565229815.pv_49231431991543)
        const getVariantId = () => {
          const bundleContainer = document.querySelector(".bundle-container");
          if (!bundleContainer) return null;

          const classes = bundleContainer.className.split(" ");
          const variantClass = classes.find((c) => c.startsWith("pv_"));
          return variantClass ? variantClass.split("_")[1] : null;
        };

        let currentVariantId = getVariantId();

        const updatePriceChecking = (variantId) => {
          const minimumPrice = babMinimums[bundleId]?.[variantId] || 0;
          console.log(`Setting up price checking for variant ${variantId} with minimum price $${minimumPrice}`);

          const setAddToCartMinimumPrice = () => {
            const bundleContainer = document.querySelector(".bundleapp-modal__container--complete-screen > .bundle-container");

            if (!bundleContainer) return;

            // Remove existing minimum price info if any
            const existingInfo = bundleContainer.querySelector(".minimum-price-info");
            if (existingInfo) {
              existingInfo.remove();
            }

            const infoDiv = document.createElement("div");
            infoDiv.className = "minimum-price-info";
            infoDiv.innerText = `Minimum price of $${minimumPrice} is required for this club.`;

            const footerDiv = bundleContainer.querySelector("footer > div");
            if (footerDiv) {
              const lastDiv = footerDiv.querySelector("div:last-child");
              if (lastDiv) {
                footerDiv.insertBefore(infoDiv, lastDiv);
              }
            }

            document.body.addEventListener("click", (e) => {
              const price = document.querySelector("div > span.bundle-text--emphasis").innerText;
              const innerPrice = parseFloat(price.replace(/[^0-9.,]/g, "").replace(",", ""));

              const addToCartButton = document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div > button");
              if (innerPrice < minimumPrice) {
                addToCartButton.classList.add("priceNotMet");
                document.body.classList.add("priceNotMet");
              } else {
                addToCartButton.classList.remove("priceNotMet");
                document.body.classList.remove("priceNotMet");
              }
            });
          };

          const checkIfPriceLabel = () =>
            document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div:last-child > div > span:nth-child(2)");

          let priceLabelSet = false;

          if (checkIfPriceLabel()) {
            setAddToCartMinimumPrice();
          } else {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (!priceLabelSet && mutation.addedNodes.length) {
                  if (checkIfPriceLabel()) {
                    setAddToCartMinimumPrice();
                    priceLabelSet = true;
                    observer.disconnect();
                  }
                }
              });
            });

            observer.observe(document.body, {
              childList: true,
              subtree: true
            });

            setTimeout(() => {
              observer.disconnect();
            }, 5000);
          }
        };

        // Initial setup if we have a variant ID
        if (currentVariantId) {
          updatePriceChecking(currentVariantId);
        }

        // Watch for variant changes in the bundle container
        const variantObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "class") {
              const newVariantId = getVariantId();
              if (newVariantId && newVariantId !== currentVariantId) {
                console.log(`Variant changed from ${currentVariantId} to ${newVariantId}`);
                currentVariantId = newVariantId;
                updatePriceChecking(currentVariantId);
              }
            }
          });
        });

        // Observe the bundle container for class changes
        const bundleContainer = document.querySelector(".bundle-container");
        if (bundleContainer) {
          variantObserver.observe(bundleContainer, {
            attributes: true,
            attributeFilter: ["class"]
          });
        }
      });
    }

    //Add subscription info blocks for all bundle products
    waitForElement(".bundleapp-modal__container--complete-screen .bundle-container", (container) => {
      const imgId = "bundle-subscription-placeholder-img";

      if (!document.getElementById(imgId)) {
        // Insert image container
        var imgContainer = document.createElement("div");
        imgContainer.className = "bundle-subscription-placeholder-img-container";

        const imgFilename = babInfoMapping[bundleId]?.img || babInfoMapping.default.img;
        var img = imgFilename ? document.createElement("img") : null;
        // The configured banner may be a full URL (a Shopify Files image, a
        // CDN) or a filename uploaded to this theme's assets/ — only the
        // filename form goes through the awtAssetPath shim.
        if (img) {
          img.src = /^https?:\/\//.test(imgFilename)
            ? imgFilename
            : window.awtAssetPath.replace("xxxxxxxx.jpg", imgFilename);
        }
        if (img) {
          img.id = imgId;
          imgContainer.appendChild(img);
        }

        var imgText = document.createElement("div");
        imgText.className = "bundle-subscription-placeholder-img-text";
        imgText.innerHTML = `<h1>${babInfoMapping[bundleId]?.title || babInfoMapping.default.title}</h1>`;
        imgContainer.appendChild(imgText);

        container.insertBefore(imgContainer, container.firstChild);

        // Insert subscription info block
        var info = document.createElement("div");
        info.className = "bundle-subscription-info";
        info.innerHTML = babInfoMapping[bundleId]?.info || babInfoMapping.default.info;
        container.insertBefore(info, imgContainer.nextSibling);

        // Insert items header before create-content
        const createContent = document.querySelector(".bundle-create-content");
        if (createContent) {
          var itemsheader = document.createElement("div");
          itemsheader.className = "bundle-subscription-itemsheader";
          itemsheader.innerHTML = babInfoMapping[bundleId]?.header || babInfoMapping.default.header;
          container.insertBefore(itemsheader, createContent);
        }
      }
    });
  }
}

/* Cart rollup is NOT part of this kit.
   This file used to end with a single-theme "remove bundle" click handler that
   zeroed every _bundleUid line via /cart/update.js. It has been removed: the
   shop-independent Awtomic Cart Rollup library (awtomic-cart-extras) supersedes
   it, handling detection, rendering and removal across every supported theme.
   Enable that library from snippets/awtomic-theme-custom.liquid — and do not
   re-add a second rollup handler here, or the two double-bind the same click. */

/* ==================================================================== */
/* ===== CX-4992 — customer portal frequency wording ================== */
/* ==================================================================== */

/* The portal builds its frequency line from the delivery interval alone, so a
   plan that delivers every 3 months reads "Every 3 months". The labels below
   are the wording from each plan's Display name in the subscriptions admin.
   Each subscription is matched on its selling plan id, so a subscription on
   any other plan keeps the standard wording.

   To change the wording, edit the text below. Edit the plan's Display name in
   the admin at the same time, so the storefront and the portal agree. */
(() => {
  /* CONFIGURE: selling plan id -> the text the portal must show. */
  const PLAN_LABELS = {
    "3361341615": "Quarterly (Feb, May, Sept, Dec)"
  };

  const PORTAL_PATH = "/tools/bundle-subscriptions";
  const DETAIL_SELECTOR = ".awt-frequency-container";
  const LIST_ITEM_SELECTOR = "[data-subscription-id]";
  const LIST_LABEL_SELECTOR = ".bundleapp-subscription-list-item__subscription-delivery-frequency";

  if (window.location.pathname.indexOf(PORTAL_PATH) === -1) return;

  const labelFor = (subscription) => {
    const line = (subscription?.Lines || []).find((l) => l.SellingPlanId);
    if (!line) return null;
    return PLAN_LABELS[String(line.SellingPlanId).split("/").pop()] || null;
  };

  /* The detail container holds the frequency as a bare text node, and swaps in
     the edit-frequency form when the shopper clicks Edit. So rewrite only the
     text node and never touch element children — setting textContent here
     would tear the open form out of the DOM. */
  const setOwnText = (el, text) => {
    if (!el) return;
    let written = false;
    el.childNodes.forEach((node) => {
      if (node.nodeType !== Node.TEXT_NODE || !node.nodeValue.trim()) return;
      if (written) {
        node.nodeValue = "";
      } else {
        if (node.nodeValue !== text) node.nodeValue = text;
        written = true;
      }
    });
  };

  /* The list label is a dedicated <span>, so it is safe to write directly.
     Write only when the text differs, so we never fight the portal's own
     re-render or loop the observer. */
  const setSpanText = (el, text) => {
    const target = el?.querySelector("span");
    if (target && target.textContent.trim() !== text) {
      target.textContent = text;
    }
  };

  const applyDetail = () => {
    const label = labelFor(window.Awtomic?.subscriptionDetails);
    if (label) setOwnText(document.querySelector(DETAIL_SELECTOR), label);
  };

  const applyList = () => {
    const items = window.Awtomic?.subscriptionList || [];
    if (!items.length) return;

    const byId = {};
    items.forEach((item) => {
      const id = String(item.SubscriptionId || "").split("/").pop();
      const label = labelFor(item);
      if (id && label) byId[id] = label;
    });

    document.querySelectorAll(LIST_ITEM_SELECTOR).forEach((row) => {
      const label = byId[row.getAttribute("data-subscription-id")];
      if (label) setSpanText(row.querySelector(LIST_LABEL_SELECTOR), label);
    });
  };

  const apply = () => {
    try {
      applyDetail();
      applyList();
    } catch (e) {
      /* Never let this break the portal. */
    }
  };

  /* The portal is a React app: it renders after page load and re-renders when
     the shopper edits the subscription. So watch the DOM as well as listening
     for the portal's own ready event. */
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  };

  window.addEventListener("awtomic-cp-loaded", schedule);

  const start = () => {
    apply();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.body) {
    start();
  } else {
    document.addEventListener("DOMContentLoaded", start);
  }
})();
